import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Helmet } from 'react-helmet';

// Core setup component
import InstanceSetup from 'client/components/Instance/InstanceSetup';

// App layout
import { MainContent, PageHeader, Content } from 'client/components/App';
import InstanceParentAlert from 'client/components/Instance/components/InstanceParentAlert';

// EATD specific components (assuming no tester for now)
import ConnectedEATDOptionsForm from 'client/components/EATD/ConnectedEATDOptionsForm';
import ConnectedEATDTester from 'client/components/EATD/ConnectedEATDTester'; // Uncomment if a tester exists

/**
 * @class EATDSetup
 * @description Wrapper component for setting up an EATD instance.
 *              Delegates most logic to the generic InstanceSetup component.
 */
export default class EATDSetup extends Component {
  static propTypes = {
    instanceId: propTypes.string.isRequired,
  };

  render () {
    const { instanceId } = this.props;

    return (
      <Content>
        <Helmet>
          <title>EATD Setup</title>
        </Helmet>
        <PageHeader>Setup Wizard: Extended Anonymization for TOPdesk</PageHeader>
        <MainContent>
          <InstanceParentAlert />
          <InstanceSetup
            id={instanceId}
            OptionsFormComponent={ConnectedEATDOptionsForm}
            TesterComponent={ConnectedEATDTester}
            endpointOrder={['topdesk']}
          />
        </MainContent>
      </Content>
    );
  }
}
